import React from 'react';
import './index.scss';

export const IconQuestionCircle: React.FC = () => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    className="icon-question-circle"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="20.5" r="18.0417" stroke="#15141D" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M20.4996 27.8334C21.1669 27.8334 21.7084 28.3742 21.7086 29.0414C21.7086 29.7087 21.167 30.2504 20.4996 30.2504C19.8324 30.2502 19.2916 29.7086 19.2916 29.0414C19.2918 28.3743 19.8325 27.8336 20.4996 27.8334Z"
      stroke="#15141D"
      strokeLinecap="round"
    />
    <path
      d="M21.5556 21.2858C24.4863 20.676 26.4792 18.7302 26.4792 15.5937C26.4792 12.5153 23.7829 10.25 20.2368 10.25C17.5112 10.25 14.6391 12.0796 14.5219 14.6353C14.4926 15.4485 15.108 15.9712 15.7821 15.9712C16.3096 15.9712 16.6613 15.7679 16.9251 15.0128C17.5698 13.1832 18.7714 12.6314 20.3247 12.6314C22.2883 12.6314 23.7243 13.8512 23.7243 15.826C23.7243 16.9005 23.3433 18.4978 21.0281 18.9625C19.0059 19.3691 18.9766 19.6014 18.9766 20.9083V24.19C18.9766 25.0322 19.4748 25.555 20.2661 25.555C21.0574 25.555 21.5556 25.0322 21.5556 24.19V21.2858Z"
      fill="#15141D"
    />
  </svg>
);
